import { signal } from "@preact/signals-react";
import { SongLikes } from "stuen-common";

export const songLikes = signal<SongLikes["listeners"]>([]);
